import axios from 'axios/index';
import React from 'react';
import { dispatch } from 'nike-re-framejs';

import { initNuiCtx } from 'nike-ui/src/common/initialization';
import { getConfigProperty, getUrl } from '@/common/oldMobile';
import n1Client from '@/_http/axiosN1Client';
import PopupNg from '@/ui/PopupNg';
import { registerPopup } from '@/ui/popupRegistrar';
import { NuiDialog } from '@/ui/dialogs/Dialog';
import Article from '@/article/views/Article';
import { NikeCmsDomain } from 'nike-ui/src/types/generated/nike-cms-domain';
import { history_back, navigate, updateURLSearchParams } from '@/routing';
import { pushClient } from '@/services/push';
import { PromoDetail } from '@/nikeone/components/PrematchDetail';
import '@/betbook';
import { TopEventsBoxes } from '@/betbook/views/BetbookTopEvents';
import { fetchPostById } from '@/betbook/handlers';
import { incrementPostViews } from 'nike-ui/src/components/betbook/handlers';
import BetbookAnalysisItem from '@/betbook/views/BetbookAnalysisItem';
import { SCRATCHCARD_I_SCRATCH_PLAY } from '@/routing/routes';
import { isLoggedIn } from '@/account';
import i18n from '@i18n';
import redirects from '@/routing/redirects';
import * as routes from '@/routing/routes';

initNuiCtx({
    platform: 'mobile',
    routing: {
        routes: Object.values(routes),
        redirects: redirects,
        navigate: navigate,
        history_back: history_back,
        updateURLSearchParams: updateURLSearchParams
    },
    openDialog: (popup, data) => {
        const Component = popup.component;
        registerPopup(popup.name, popup => <Component {...popup.get('data')} />);
        PopupNg.dispatcher.open(popup.name, Object.assign({ close: () => PopupNg.dispatcher.close(popup.name) }, data));
    },
    closeDialog: popup => {
        PopupNg.dispatcher.close(popup.name);
    },
    closeAllDialogs: () => {
        PopupNg.dispatcher.closeAll();
    },
    openLoginDialog: title => {
        PopupNg.dispatcher.open('dialog/login4action', { bodyText: title }, 20);
    },
    openLoginPage: () => {
        dispatch(['login.openScreen']);
    },
    user: {
        isloggedIn: !!window.USER_DATA_SNAPSHOT.cisloZmluvy
    },
    components: {
        NuiDialog,
        //ToDo treba zistit a opravit preco v promoPage nefunguje dispatch na ulozenie dat zo sluzby,
        // ako fix pouzivame dispatchSync, na inych miestach funguje povodny dispatch
        MarkdownArticle: niceUrl => <Article articleCode={niceUrl} type={'marketing'} isPromoPage />,
        PrematchDetail: (boxStore, boxId, matchId) => <PromoDetail matchId={matchId} isPromoPage />,
        // @ts-ignore
        BetbookPostItem(postType, post, detail, header) {
            dispatch(fetchPostById(postType, post.id));
            incrementPostViews(postType, post.id);
            return <BetbookAnalysisItem post={post} detail={detail} />;
        },
        BetbookTopEvents: () => <TopEventsBoxes dataAtid="naj10-box" />
    },
    getArticle: async niceUrl => {
        return (
            axios
                .get(getUrl('MARKDOWN_MARKETING_ARTICLE_BY_URL'), {
                    params: { url: niceUrl }
                })
                // @ts-ignore
                .then((data: { article?: MarkdownArticleDto }) => {
                    if (!data?.article) {
                        return Promise.reject('Article not found');
                    }
                    return data.article as NikeCmsDomain.MarkdownArticleDto;
                })
        );
    },
    pushClient,
    services: {
        nikeone: n1Client
    },
    properties: {
        'cake-cms.image.link.url': getConfigProperty('cake-cms.image.link.url'),
        'static.url': getConfigProperty('static.url'),
        'cakeCms.endpoint.url': getConfigProperty('cakeCms.endpoint.url'),
        'fe-dwh.endpoint.url': getConfigProperty('fe-dwh.endpoint.url')
    },
    handlers: {
        cashinOfferPush: message => {
            dispatch(['ticketus/cashin-offer/push', message]);
        },
        cashinOfferSnapshot: messages => {
            dispatch(['ticketus/cashin-offer/snapshot', messages]);
        },
        cashinOfferFailure: error => {
            dispatch(['ticketus/cashin-offer/failure']);
        }
    },
    casino: {
        'casino.notificationByFun.timeout': getConfigProperty('casino.notificationByFun.timeout'),
        'casino.image.link.url': getConfigProperty('casino.image.link.url'),
        lotteryPlayGame: (gameId, mode: 'fun' | 'money') => {
            if (!isLoggedIn() && mode === 'money') {
                PopupNg.dispatcher.open('dialog/login4action', { bodyText: i18n('casino.favorite.notLoggedMessage') });
            } else {
                navigate(SCRATCHCARD_I_SCRATCH_PLAY, { gameId, mode });
            }
        }
    }
});
